import React, { useEffect, useState } from "react";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import useEncryption from "../useEncryption/useEncryption";
// import * as mammoth from "mammoth/mammoth.browser.js";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import axiosInstanceAuthFormData from "../../apiInstances/axiosInstanceAuthFormData";

import { MdOutlineKeyboardBackspace } from "react-icons/md";

const DocxConverter = (props) => {
  const {
    setadd,
    isOpen,
    setIsOpen,
    savedContent,
    docxContent,
    setDocxContent,
    id,
    mytemplateIDData,
    setIsOpenEdit,
    dateVersionDocx,
    setIsLoading,

    getViewallSubmitForm,
  } = props;
  // const [docxContent, setDocxContent] = useState("");
  // const [savedContent, setSavedContent] = useState(""); // State to store saved content

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setDocxContent(data);
  };

  // const handleFileUpload = (file) => {
  //   const reader = new FileReader();
  //   reader.onload = async (event) => {
  //     const docxFile = event.target.result;
  //     const { value } = await mammoth.convertToHtml({ arrayBuffer: docxFile });
  //     setDocxContent(value);
  //   };
  //   reader.readAsArrayBuffer(file);
  // };

  const saveContent = () => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append(
      "templete",
      new Blob([docxContent], { type: "text/html" }),
      "content.html"
    );
    axiosInstanceAuthFormData
      .post(`getdata`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      .then((res) => {
        setIsOpen(!isOpen);
        console.log("----------------chintan-----------------");
        setadd(false);
        setIsLoading(true);
        // getSopsData();

        getViewallSubmitForm();
        console.log("----------------pintu-----------------");
        // window.location.reload(false);
        console.log(res);

        // const data =  decryptData()
        // console.log("🚀 ~ .then ~ data:", data)
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    // <Layout>
    <div className="m-8">
      {/* <Link to="/"> */}
      <div
        className="text-xl font-bold font-sans text-[#22345C]  flex items-center gap-1 cursor-pointer"
        onClick={() => {
          // window.location.reload(false);
          setIsOpen(!isOpen);
          setadd(false);
          setIsOpenEdit(true);
        }}
      >
        <MdOutlineKeyboardBackspace size={25} />
        Back
      </div>
      {/* </Link> */}

      <div className="flex justify-between">
        <div>
          <h1 className="text-2xl font-bold font-sans mb-5 mt-5 text-[#22345C]">
            Title : {dateVersionDocx?.data?.title}
          </h1>
        </div>
        <div className="mb-3 mt-3 space-y-1">
          <h1 className="text-xl font-bold font-sans text-[#22345C]">
            Version : {dateVersionDocx?.data?.version}
          </h1>
          <h1 className="text-xl font-bold font-sans  text-[#22345C]">
            Last Edited : {dateVersionDocx?.data?.date}
          </h1>
          <h1 className="text-xl font-bold font-sans  text-[#22345C]">
            Edited By : {dateVersionDocx?.data?.edit_by}
          </h1>
        </div>
      </div>

      {/* <h1 className="text-2xl font-bold font-sans mb-5 text-[#22345C]">
        File Name : 
      </h1> */}

      {/* <FileUpload onFileUpload={handleFileUpload} /> */}
      {/* <Procedures onFileUpload={handleFileUpload} /> */}
      <CKEditor
        editor={ClassicEditor}
        data={mytemplateIDData || docxContent}
        onChange={handleEditorChange}
      />
      <div className="flex gap-2">
        <button
          className="bg-[#22345C] gap-1 justify-end  text-[#FFFFFF] font-sans text-lg font-bold py-1 mt-5 px-4 rounded-[10px] inline-flex items-center"
          onClick={saveContent}
        >
          Save
        </button>
        {/* {savedContent && ( */}

        <div dangerouslySetInnerHTML={{ __html: savedContent }}></div>
      </div>
      {/* )} */}
    </div>
    // </Layout>
  );
};

export default DocxConverter;
